export type TChannelInterpretation = 'discrete' | 'speakers';
